// extracted by mini-css-extract-plugin
export var fadeInOut = "_3r-3";
export var icon = "_3r-4";
export var savedIndicator = "_3r-2";
export var savingIndicator = "_3r-0";
export var spin = "_3r-1";